module.exports = __webpack_public_path__ + "img/318.79ed45e9.png";